import { render, staticRenderFns } from "./tradingItem.vue?vue&type=template&id=35423509&scoped=true"
import script from "./tradingItem.vue?vue&type=script&lang=js"
export * from "./tradingItem.vue?vue&type=script&lang=js"
import style0 from "./tradingItem.vue?vue&type=style&index=0&id=35423509&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35423509",
  null
  
)

export default component.exports